export default __webpack_public_path__ + "static/popup-leaf-9ed81b97bfaa3fcc994a77c656ff106a.png";